module.exports = __webpack_public_path__ + "static/media/house1.f6bcb7e2.svg";